import React from 'react';

export const ProductsIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 21, width = 25, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 25 21"
    className={className}
  >
    <title>Products icon</title>
    <desc>
      Products icon
    </desc>
    <path
      d="M6.897 0C7.849 0 8.62.895 8.62 2L8.62 5h14.656C24.228 5 25 5.895 25 7v12c0 1.105-.772 2-1.724 2H1.724C.772 21 0 20.105 0 19V2C0 .895.772 0 1.724 0h5.173Zm16.378 17H8.62v2h14.656l-.001-2ZM6.896 13H1.724v6h5.173l-.001-6Zm-1.724 2v2H3.448v-2h1.724Zm3.448 0h14.655v-4H8.62v4Zm6.897-3v2h-1.724v-2h1.724ZM6.897 2H1.724v9h5.172V2Zm16.379 5H8.62L8.62 9h14.655V7Z" // eslint-disable-line
      fillRule="evenodd"
    />
  </svg>
);
